import React, { useRef } from "react"
import Box from "@mui/material/Box"
import FormControl from "@mui/material/FormControl"

import { Controller } from "react-hook-form"
import {
  Button,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material"

import AttachmentOutlinedIcon from "@mui/icons-material/AttachmentOutlined"
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined"
import Link from "@mui/material/Link"
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined"

interface IProps {
  name: string
  error?: any
  label?: string
  control: any
  isRequired?: boolean
  disabled?: boolean
  type?: string
}

const SingleFileField = React.forwardRef<HTMLInputElement, IProps>((props: IProps, ref) => {
  const { name, error, label, control, isRequired } = props
  const inputRef = useRef<HTMLInputElement>(null)

  const handleClick = () => {
    if (inputRef.current) inputRef.current.value = ""
  }

  function parseValue(value: string | File) {
    if (typeof value === "string" || value instanceof String) {
      const parts = value.split("/")
      const sanitized = parts[parts.length - 1]
      const parts2 = sanitized.split("?")
      const sanitized2 = parts2[0]

      return (
        <Link
          color="inherit"
          underline="none"
          href={`${value}`}
          target="_blank"
        >
          {sanitized2}
        </Link>
      )
    } else if (typeof window !== "undefined" && value instanceof File) {
      return (
        <Link
          color="inherit"
          underline="none"
          href={`${URL.createObjectURL(value)}`}
          target="_blank"
        >
          {value.name}
        </Link>
      )
    }

    return ""
  }

  return (
    <FormControl fullWidth>
      <Controller
        control={control}
        name={name}
        render={({ field }) => {
          const files = field.value && Object.values(field.value)

          return (
            <>
              <input
                type="file"
                onChange={(e) => field.onChange(e.target.files)}
                onClick={handleClick}
                hidden
                ref={inputRef}
              />
              <Button
                onClick={() => inputRef.current?.click()}
                variant="outlined"
                component="label"
                startIcon={<CloudUploadOutlinedIcon />}
              >
                Upload {props.label}
              </Button>

              {files && files.length ? (
                <Box
                  sx={{
                    p: 1,
                    my: 2,
                    bgcolor: "#fff",
                    border: "1px solid #eee",
                  }}
                >
                  <List>
                    {files.map((file: string | File) => (
                      <ListItem
                        disablePadding
                        secondaryAction={
                          <IconButton onClick={() => field.onChange(null)}>
                            <DeleteOutlineOutlinedIcon />
                          </IconButton>
                        }
                      >
                        <ListItemIcon>
                          <AttachmentOutlinedIcon />
                        </ListItemIcon>
                        <ListItemText>{parseValue(file)}</ListItemText>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              ) : null}
            </>
          )
        }}
        rules={{ required: isRequired }}
      />
    </FormControl>
  )
})

SingleFileField.defaultProps = {
  isRequired: false,
}

export { SingleFileField }
